//src/admin/pages/AdminShippingSettings.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaSave, FaTruck } from "react-icons/fa";
import {
  getAdminShippingSettings,
  saveAdminShippingSettings,
} from "../../services/adminShippingSettings.api";
import { AdminLanguageContext } from "../context/AdminLanguageContext";

function AdminShippingSettings() {
  const { lang } = useContext(AdminLanguageContext);

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  const [toast, setToast] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);

  const [form, setForm] = useState({
    default_fee: 4,
    free_enabled: false,
    free_threshold: 50,
  });

  const TEXT = {
  EN: {
    title: "Shipping Settings",
    defaultFee: "Default Shipping Fee ($)",
    enableFree: "Enable Free Shipping",
    freeThreshold: "Free Shipping Threshold ($)",
    save: "Save",
    saving: "Saving…",
    loading: "Loading…",
    confirmTitle: "Save Shipping Settings",
    confirmText: "Are you sure you want to save these changes?",
    cancel: "Cancel",
    confirm: "Confirm",
    success: "Shipping settings saved successfully",
  },
  AR: {
    title: "إعدادات الشحن",
    defaultFee: "رسوم الشحن الافتراضية ($)",
    enableFree: "تفعيل الشحن المجاني",
    freeThreshold: "الحد الأدنى للشحن المجاني ($)",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    loading: "جارٍ التحميل…",
    confirmTitle: "حفظ إعدادات الشحن",
    confirmText: "هل أنت متأكد أنك تريد حفظ هذه التغييرات؟",
    cancel: "إلغاء",
    confirm: "تأكيد",
    success: "تم حفظ إعدادات الشحن بنجاح",
  },
};

const t = TEXT[lang];

const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";
const canAccess = isAdmin || perms.can_manage_shipping;



  useEffect(() => {
    getAdminShippingSettings()
      .then(setForm)
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
  setSaving(true);
  try {
    await saveAdminShippingSettings(form);

setToast(t.success);
setShowToast(true);

setTimeout(() => {
  setShowToast(false);
  setToast(null);
}, 3000);
  } finally {
    setSaving(false);
    setShowConfirm(false);
  }
};

  return (
   <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
  
  

  <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
  <div className="flex-1 lg:ml-64">

        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-6 max-w-[560px] mx-auto animate-fadeSlide">
  {!canAccess && (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "ليس لديك صلاحية لإدارة إعدادات الشحن"
          : "You do not have permission to manage shipping settings."}
      </p>
    </div>
  )}

  {canAccess && (
    <>

          <h1 className="text-[20px] font-semibold text-gray-900 flex items-center gap-2 mb-5">
            <FaTruck /> {t.title}
          </h1>

          {loading ? (
            <p>{t.loading}</p>
          ) : (
            <div
className="
bg-white
border border-[#e3e3e3]
rounded-[14px]
p-6
space-y-5
shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
"
>
              <div>
               <label className="text-sm font-semibold text-gray-900">{t.defaultFee}</label>
                <input
                  type="number"
                  className="
w-full
h-[42px]
px-3
mt-1
text-sm
border border-gray-300
rounded-[10px]
bg-white
focus:border-gray-500
focus:ring-2
focus:ring-gray-200
outline-none
transition
"
                  value={form.default_fee}
                  onChange={(e) =>
                    setForm({ ...form, default_fee: Number(e.target.value) })
                  }
                />
              </div>

              <label className="flex items-center gap-3">
  <input
    type="checkbox"
     className="w-4 h-4 accent-gray-800"
    checked={form.free_enabled}
    onChange={(e) =>
      setForm({ ...form, free_enabled: e.target.checked })
    }
  />
  {t.enableFree}
</label>

              {form.free_enabled && (
                <div>
                  <label className="text-sm font-semibold text-gray-900">
                    {t.freeThreshold}
                  </label>
                  <input
                    type="number"
                    className="
w-full
h-[42px]
px-3
mt-1
text-sm
border border-gray-300
rounded-[10px]
bg-white
focus:border-gray-500
focus:ring-2
focus:ring-gray-200
outline-none
transition
"
                    value={form.free_threshold}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        free_threshold: Number(e.target.value),
                      })
                    }
                  />
                </div>
              )}

              <button
  onClick={() => setShowConfirm(true)}
  disabled={saving}
  className="
h-[38px]
px-4
bg-[#202223]
text-white
rounded-[10px]
text-sm font-medium
flex items-center gap-2
shadow-[0_1px_0_rgba(0,0,0,0.05)]
hover:bg-black
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.15)]
transition
"
>
  <FaSave /> {saving ? t.saving : t.save}
</button>

            </div>
          )}

          {showConfirm && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div
className="
w-[380px]
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_20px_60px_rgba(0,0,0,0.15)]
overflow-hidden
animate-sortOverlay
"
>
      <div className="px-5 py-4 border-b border-gray-200 bg-[#f6f6f7]">
      <h3 className="text-[15px] font-semibold text-gray-800">
        {t.confirmTitle}
      </h3>
      </div>

      <div className="px-5 py-5 text-sm text-gray-600">
        {t.confirmText}
      </div>

      <div className="flex justify-end gap-3 px-5 py-4 border-t border-gray-200 bg-[#f6f6f7]">
        <button
          onClick={() => setShowConfirm(false)}
          className="
h-[36px] px-4
bg-white
border border-gray-300
rounded-lg
text-sm font-medium text-gray-900
hover:bg-gray-50
transition
"
        >
          {t.cancel}
        </button>

        <button
          onClick={save}
          disabled={saving}
          className="
h-[36px] px-4
bg-[#202223]
text-white
rounded-lg
text-sm font-medium
hover:bg-black
transition
"
        >
          {t.confirm}
        </button>
      </div>
    </div>
  </div>
)}
    </>
  )}

{showToast && (
<div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">

<div
className="
flex items-center gap-3
px-4 py-3
bg-white
border border-gray-200
rounded-[12px]
shadow-[0_10px_30px_rgba(0,0,0,0.12)]
"
>

<div
className="
flex items-center justify-center
w-7 h-7
rounded-full
bg-green-100
"
>
<span className="text-green-700 text-sm">✓</span>
</div>

<div className="text-sm text-gray-800 font-medium">
{toast}
</div>

</div>

</div>
)}

        </main>
      </div>
    </div>
  );
}

export default AdminShippingSettings;
